import React from 'react';
export function PressStrip() {
  const items = ['Detroit Pistons Game', 'Community Pop-Ups', 'National Outreach Events', 'Lifeline Program Partner', 'Local Health Fairs'];
  // Duplicate items for seamless marquee
  const marqueeItems = [...items, ...items, ...items];
  return <div className="bg-brand-black border-y border-brand-concrete py-6 overflow-hidden flex items-center relative" data-id="element-143">
      <div className="absolute inset-0 film-grain z-0" data-id="element-144" />
      <div className="flex whitespace-nowrap animate-[marquee_30s_linear_infinite] relative z-10 w-max" data-id="element-145">
        {marqueeItems.map((item, idx) => <div key={idx} className="flex items-center mx-8 group" data-id="element-146">
            <span className="text-brand-soft/40 font-mono text-[13px] tracking-widest mr-4 uppercase group-hover:text-brand-lime transition-colors" data-id="element-147">
              AS SEEN AT
            </span>
            <span className="text-brand-soft font-mono font-bold tracking-widest uppercase text-sm group-hover:text-brand-lime transition-colors" data-id="element-148">
              {item}
            </span>
            <span className="mx-8 text-brand-concrete" data-id="element-149">•</span>
          </div>)}
      </div>
      <style data-id="element-150">{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `}</style>
    </div>;
}